import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { logo, physicianchat, profileimg } from "../Constant/Index";
import MyModal from "../Components/MyModal";

const PhysicianWriteNotes = () => {
	const [show, setShow] = useState(false);

	const handleShow = () => setShow(true);
	const handleClose = () => setShow(false);
	return (
		<>
			<Header />
			<PageHeader pagename="Write Prescription " />
			<section className="main-sidebar user-profile Physician">
				<div className="container">
					<div className="row">
						<div className="col-lg-8 mx-auto">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex gap-3 align-items-center">
										<img src={profileimg} className="img-fluid" alt="" />
										<div>
											<h4 class="main-heading-font level-6 mb-0">
												Dr David Patel
											</h4>
											<h5 class="primary-medium-font level-8  mb-0 extra-color-15">
												Physician
											</h5>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="note-write-texterea">
											<img src={logo} className="img-fluid" alt="" />
										</div>
										<div className="row">
											<div className="col-lg-12">
												<div className="write-texterea">
													<div class="form-group col-lg-12">
														<textarea
															class="form-control"
															id="message"
															rows="4"
															placeholder="You can Write Notes here for your help"
														></textarea>
													</div>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-lg-12">
												<Link
													class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													href="/user-write-now"
													onClick={handleShow}
												>
													<span class="bg-wrapper w-100">Save Changes</span>
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<div className="row">
				<div className="col-lg-12">
					<MyModal show={show} handleClose={handleClose} />
				</div>
			</div>
			<Footer />
		</>
	);
};

export default PhysicianWriteNotes;
